import React from "react"
import styled from "styled-components"

export default function CircleBG({ className }) {
  return (
    <Wrapper className={className}>
      <div className="circle c1"></div>
      <div className="circle c2"></div>
      <div className="circle c3"></div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: absolute;
  will-change: transform;

  .circle {
    width: 100px;
    height: 100px;
    /* background-color: #00fff0; */
    position: absolute;
    will-change: transform;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  .c1 {
    animation: circle 5s infinite ease;
  }
  .c2 {
    animation: circle 5s infinite ease 1s;
  }
  .c3 {
    animation: circle 5s infinite ease 2s;
  }

  @keyframes circle {
    0% {
      transform: translate(-50%, -50%) scale(0.1);
      border: #00ffee19 1px solid;
    }

    90% {
      transform: translate(-50%, -50%) scale(20);
      border: #00ffee43 0.00001px solid;
    }
    100% {
      transform: translate(-50%, -50%) scale(20);
      border: #00ffee43 0.00001px solid;
      opacity: 0;
    }
  }
`
